module.exports = __webpack_public_path__ + "img/toolbar_ck.1eb3a0b0.png";